import { produce } from 'immer';
import { wrapReducers } from '~/state/lib';

const DEFAULT_STATE = {
  isEnabled: false,
  selected: null,
  source: 'RG FB Tool Lead Ad',
};

const reducer = {
  setLeadSource: produce((draft, source) => {
    draft.source = source;
  }),
  setSelectedForm: produce((draft, formId) => {
    draft.selected = formId;
  }),
  enableLeadAd: produce((draft) => {
    draft.isEnabled = true;
  }),
  disableLeadAd: produce((draft) => {
    draft.isEnabled = false;
    draft.selected = null;
  }),
};

export default wrapReducers(reducer, DEFAULT_STATE);
